// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ZuS5q","subwrapper":"_12698D","accessButton":"_3fpiba","commentsWrapper":"_3_sw1O","commentsList":"_19sEYl","staticShowMoreLabel":"_2OV8K6"};